export const stepVote = [
    {
        id: 1,
        index: 1,
        name: 'Setup'
        
    },
    {
        id: 2,
        index: 2,
        name: 'Target'
    },
    {
        id: 3,
        index: 3,
        name: 'Detail'
    },
    {
        id: 4,
        index: 4,
        name: 'Award',
        position: 1
    },
    {
        id: 5,
        index: 5,
        name: 'Announcement',
        position: 1
    },
    {
        id: 6,
        index: 4,
        name: 'Submit'
    }
]

export const stepQuiz = [
    {
        id: 1,
        index: 1,
        name: 'Setup'
        
    },
    {
        id: 2,
        index: 2,
        name: 'Target'
    },
    {
        id: 3,
        index: 3,
        name: 'Detail'
    },
    {
        id: 4,
        index: 4,
        name: 'Award',
        position: 1
    },
    {
        id: 5,
        index: 5,
        name: 'Announcement',
        position: 1
    },
    {
        id: 6,
        index: 6,
        name: 'Submit'
    }
]

export const stepScore = [
    {
        id: 1,
        index: 1,
        name: 'Setup'
        
    },
    {
        id: 2,
        index: 2,
        name: 'Target'
    },
    {
        id: 3,
        index: 3,
        name: 'Detail'
    },
    {
        id: 4,
        index: 4,
        name: 'Award',
        position: 1
    },
    {
        id: 5,
        index: 5,
        name: 'Announcement',
        position: 1
    },
    {
        id: 6,
        index: 6,
        name: 'Submit'
    }
]